import { render, staticRenderFns } from "./softTop.vue?vue&type=template&id=533c738c&scoped=true&"
import script from "./softTop.vue?vue&type=script&lang=js&"
export * from "./softTop.vue?vue&type=script&lang=js&"
import style0 from "./softTop.vue?vue&type=style&index=0&id=533c738c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c738c",
  null
  
)

export default component.exports